module.exports = __webpack_public_path__ + "static/media/folder.53aebdb4.svg";